import React, { Component } from 'react';

import Modal from "../../../src/component/modal/ModalTemplate";
import SingleButton from "../button/SingleButton";
import TextInput from "../input/TextInput";

import * as apiUtil from "../../util/apiUtil";

class PoiSearchModal extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleChangeAddrValue = this.handleChangeAddrValue.bind(this);
        this.ajaxPoiSearch = this.ajaxPoiSearch.bind(this);
        this.setAddress = this.setAddress.bind(this);

        this.state = {
            loading: false,

            searchKey: '',
            addrList: [],

            addrValue: '',
        }
    }

    setLoading(loading) {
        this.setState({ loading: loading })
    }

    setValue(id, value) {
        switch (id) {
            case "searchKey":
                this.setState({ searchKey: value });
                break;
            default:
                break;
        }
    }

    handleChangeAddrValue(value) {
        this.setState({ addrValue: value });
    }

    ajaxPoiSearch() {
        const { searchKey } = this.state;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/maptics/poi",
            method: apiUtil.requestMethod.POST,
            data: {
                searchKey: searchKey,
            },
            success: (result) => {
                this.setState({ addrList: result });
            }
        })
    }

    setAddress() {
        const { setAddress, handleClose } = this.props;
        const { addrValue } = this.state;
        setAddress("address", addrValue);
        handleClose();
    }

    render() {
        const { isOpen, handleClose } = this.props;

        const { searchKey, addrList, addrValue } = this.state;
        const { setValue, handleChangeAddrValue, ajaxPoiSearch, setAddress } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                className="react-modal"
                modalTitle="주소 검색"
                overlayClassName="modal-overlay"
            >
                <div className='modal-body'>
                    <div className="d-flex gap-2 mb-3">
                        <TextInput
                            className='form-control'
                            type="text"
                            id="searchKey"
                            placeholder="정확한 도로명 주소를 입력해 주세요"
                            value={searchKey}
                            onKeyDown={ajaxPoiSearch}
                            onChange={setValue}
                        />
                        <SingleButton
                            className="btn btn-sm btn-primary white-space-nowrap"
                            label="검색"
                            handleClick={ajaxPoiSearch}
                        />
                    </div>
                    <div
                        className="overflow-y-auto d-flex flex-column p-3 gap-3"
                        style={{ border: "1px solid #e2e3e5", borderRadius: 5, height: 300 }}
                    >
                        {
                            addrList.map((item, index) =>
                                <div key={index} className="d-flex pointer" onClick={() => handleChangeAddrValue(item)}>
                                    <input
                                        className='form-check-input'
                                        type="radio"
                                        checked={item === addrValue}
                                        onChange={() => handleChangeAddrValue(item)}
                                    />
                                    <p className="m-0 ps-2">{item}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className='modal-footer'>
                    <SingleButton
                        className="btn btn-secondary btn-md me-2"
                        label="취소"
                        handleClick={handleClose}
                    />
                    <SingleButton
                        className="btn btn-primary btn-md"
                        label="선택"
                        handleClick={setAddress}
                    />
                </div>
            </Modal>
        )
    }
}

PoiSearchModal.defaultProps = {
    isOpen: false,
    handleClose: function() {},
}

export default PoiSearchModal;
